export default __webpack_public_path__ + "static/media/slot1.3bba1c15.png";